import { GatsbyImage } from "gatsby-plugin-image";
import React, { useRef, useState } from "react";
import cn from "classnames";
import { Button } from "~components";
import * as styles from "./styles.module.scss";

const VideoResourceTile = ({ title, description, image, video, link }) => {
  /** ============================================================================
   * @component
   * Link to external video resources, show short looping preview when hovered
   *
   * @param  {string}  				title 					Product title
   * @param  {string}  				description     Product price
   * @param  {GatsbyImage}  	image       		Previous product price
   * @param  {SanityFile}  		video       		Product description
   * @param  {link}  					link 						URL and newWindow
   *
   * @return {node}
   */

  const [isHovered, setIsHovered] = useState(false);
  const videoRef = useRef(null);

  const handleMouseEnter = () => {
    if (!video) return;
    setIsHovered(true);
    videoRef.current.play();
  };
  const handleMouseLeave = () => {
    if (!video) return;
    setIsHovered(false);
    videoRef.current.pause();
  };

  return (
    <div>
      <a
        href={link?.url}
        target={link?.newWindow ? `_blank` : `_self`}
        rel={link?.newWindow ? `noopener noreferrer` : null}
        className={cn(`button-text`, styles.linkContainer, {
          [styles.hovered]: isHovered
        })}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {video && (
          <video
            ref={videoRef}
            muted
            loop
            src={video?.asset?.url}
            className={styles.video}
          />
        )}
        <div className={styles.imageContainer}>
          {image && (
            <GatsbyImage
              image={image?.asset?.gatsbyImageData}
              alt={image?.altText || ``}
              style={{ width: `100%`, height: `100%` }}
            />
          )}
        </div>

        {link && (
          <Button
            display
            className={styles.linkPill}
            light
            iconRight="playCircle"
          >
            {link.title}
          </Button>
        )}
      </a>
      <div className={cn(`h4`, styles.title)}>{title}</div>
      <p className="b1">{description}</p>
    </div>
  );
};

export default VideoResourceTile;
